/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmailDeliveryOptionEnum } from '../models/EmailDeliveryOptionEnum';
import type { SendSignatureModelReq } from '../models/SendSignatureModelReq';
import type { SendSignatureModelResp } from '../models/SendSignatureModelResp';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SignatureService {

  /**
   * @param formData 
   * @returns number Created
   * @throws ApiError
   */
  public static postSignatures(
formData?: {
Base64Signature?: string;
SignatureFile?: Blob;
SoHeaderId?: number;
CheckInId?: number;
QuoteIds?: Array<number>;
EmailDeliveryOption?: EmailDeliveryOptionEnum;
'Doucment.PageUrl'?: string;
'Doucment.FileName'?: string;
},
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/signatures',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param signatureId 
   * @returns SendSignatureModelResp Success
   * @throws ApiError
   */
  public static getSignatures(
signatureId: number,
): CancelablePromise<SendSignatureModelResp> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/signatures/{signatureId}',
      path: {
        'signatureId': signatureId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param signatureId 
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static patchSignatures(
signatureId: number,
requestBody?: SendSignatureModelReq,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/signatures/{signatureId}',
      path: {
        'signatureId': signatureId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param signatureId 
   * @returns number Success
   * @throws ApiError
   */
  public static deleteSignatures(
signatureId: number,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/signatures/{signatureId}',
      path: {
        'signatureId': signatureId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

}
